import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BoardsInformationDropdownTemplate from "@Broker/handlebars-templates/clients/board/_boards-information-dropdown.hbs";
import { mapActions } from "vuex";
import Select2 from "@Shared/components/inputs/select2";
import { CREATE_STATE_COLUMN, TRANSFER_BOARD_CLIENT_PROFILE } from "@Broker/@Modules/clients/board/store/board-actions";
import { GenericModal } from "@Shared/components/modals";
import { cloneDeep } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "TransferClientProfileModal",
  components: {
    GenericModal,
    Select2
  },
  props: {
    clientProfileId: {
      type: [String, Number],
      required: true
    },
    clientProfileName: {
      type: String,
      required: true
    },
    boards: {
      type: Array,
      required: true
    },
    statusLabelId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      modalOpened: false,
      selectedBoardId: null
    };
  },
  computed: {
    options() {
      const formatResult = state => $(BoardsInformationDropdownTemplate(_objectSpread(_objectSpread({}, state), {}, {
        clients: this.$tc("global.doorr.client", state.numberOfClients),
        boardOwner: this.$t("boards.messages.boardOwner")
      })));
      return {
        templateResult: formatResult,
        allowClear: false,
        dropdownCssClass: "transfer-boards-vue-select",
        dropdownParent: "#transfer-client-form",
        placeholder: `${this.$t("boards.actions.selectABoard")} ...`,
        escapeMarkup(markup) {
          return markup;
        }
      };
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("BoardStore", [CREATE_STATE_COLUMN, TRANSFER_BOARD_CLIENT_PROFILE])), {}, {
    handleShow() {
      this.modalOpened = true;
    },
    handleHidden() {
      this.modalOpened = false;
      this.resetFields();
    },
    formatData(data) {
      data = cloneDeep(data);
      return data && _mapInstanceProperty(data).call(data, ref => {
        const isDefault = ref.default && ref.owner;
        ref.text = `${ref.name}${isDefault ? ` (${this.$t("global.words.default").toLowerCase()})` : ""}`;
        return ref;
      });
    },
    handleChange(data, type) {
      if (type === "select") {
        this.selectedBoardId = data.id;
      }
    },
    resetFields() {
      this.selectedBoardId = null;
    },
    async handleSubmit() {
      const {
        submitButton,
        modal
      } = this.$refs;
      $(submitButton).animateButton().animate("start");
      try {
        await $(submitButton).animateButton().animate("finish");
        modal.hide();
        await this.TRANSFER_BOARD_CLIENT_PROFILE({
          boardId: this.selectedBoardId,
          clientProfileId: this.clientProfileId,
          statusLabelId: this.statusLabelId
        });
      } catch (e) {
        $(submitButton).animateButton().animate("finish", "failed");
      }
    }
  })
});